// extracted by mini-css-extract-plugin
export default {"cet_about_image":"home_cet_about_image__IBcmV"};